export const ANNOTATION_COLORS = [
  // red
  "#FF0000",

  // green
  "#00FF11",

  // blue,
  "#0015FF",

  // yellow
  "#EFFF0E",

  // black
  "#000000",

  // white
  "#FFFFFF",
];
